import { renderPage } from "renderPage"
import { HomeIndexPage } from "./Page"

renderPage({ component: HomeIndexPage })
